import { StateNode, TLStateNodeConstructor } from "tldraw"
import { CustomDrawing } from "./CustomDrawing"
import { CustomIdle } from "./CustomIdle"

export class DrawStrokeTool extends StateNode {
  static override id = "draw-stroke"
  static override initial = "custom-idle"
  static override isLockable = false
  static override children(): TLStateNodeConstructor[] {
    return [CustomIdle, CustomDrawing]
  }

  override shapeType = "custom-draw"

  override onExit() {
    const drawingState = this.children!["custom-drawing"] as CustomDrawing
    drawingState.initialShape = undefined
  }
}
